export const formatFormErrors = (str = '') => {
  const words = str.trim().split(/\s+/);

  if (words.length <= 1 || /^[A-Z\s]+$/.test(str)) {
    return str.trim().replace(/\b\w/g, char => char.toUpperCase());
  }

  const [firstWord] = words;

  if (/^[A-Z]+$/.test(firstWord)) {
    return str.trim();
  }

  const indexFirstSpace = str.indexOf(' ');
  const firstPart = str.slice(0, indexFirstSpace);
  const restPart = str.slice(indexFirstSpace + 1);

  const camelCaseMatch = firstPart.match(/([A-Z]?[a-z]*)/g);
  if (!camelCaseMatch) {
    return str.trim();
  }

  const firstWordCapitalized = firstPart
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return `${firstWordCapitalized} ${restPart}`;
};

export const formatMessage = (inputMessage: string) => {
  return inputMessage.split(' ').slice(0, -1).join(' ');
};
